import { User } from 'types/auth'
import { FlowTypeEnum, UserStatusEnum } from 'types/subscription'

export const isUserOnFreeTrial = (user: User | null): boolean => {
	return (
		user?.flow === FlowTypeEnum.SOME_DAYS_FREE &&
		user?.status === UserStatusEnum.FREEMIUM_NEW
	)
}
